import { render, staticRenderFns } from "./Saannot.vue?vue&type=template&id=30a52d7c&scoped=true"
var script = {}
import style0 from "./Saannot.vue?vue&type=style&index=0&id=30a52d7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a52d7c",
  null
  
)

export default component.exports